module.exports = __webpack_public_path__ + "img/202109-group.d8589e08.jpg";